import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../View/home.vue'),
        meta: {
            title: "CorpLens-Your business assistant",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "about" */ '../View/privacy.vue'),
        meta: {
            title: "CorpLens-Privacy",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    {
        path: '/relyvia/privacy',
        name: 'relyviaPrivacy',
        component: () => import(/* webpackChunkName: "about" */ '../View/relyviaPrivacy.vue'),
        meta: {
            title: "Relyvia Privacy Policy",
            description: "Relyvia privacy policy for SMS-based bill and repayment reminder management.",
        }
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "about" */ '../View/terms.vue'),
        meta: {
            title: "CorpLens-Terms of use",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    {
        path: '/deleteAccount',
        name: 'deleteAccount',
        component: () => import(/* webpackChunkName: "about" */ '../View/deleteAccount.vue'),
        meta: {
            title: "CorpLens-Delete Account",
            description: "CorpLens provides users with a convenient company details query service.Through a quick search, you can obtain company registration records, operating conditions, shareholder information, etc.",
        }
    },
    {
        path: '/Contact',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ '../View/Contact.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
